<template>
    <div :class="{ 'container-user': !isExpert && ! isAdmin }">
        <div class="row">
            <div class="col bg-app-gray padding-0  my-custom-col">

                <expert-home v-if="isExpert"/>
                <admin-home v-else-if="isAdmin" />
                <user-home v-else />

            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";
    import UserHome from "@/views/user/UserHome.vue";
    import ExpertHome from "@/views/expert/ExpertHome.vue";
    import AdminHome from "@/views/admin/AdminHome.vue";

    @Component({
        components: {
            ExpertHome,
            UserHome,
            AdminHome,
        },
    })
    export default class Home extends Vue {
        get isExpert(): boolean {
            return this.$store.getters["authentication/isExpert"] as boolean;
        }

        get isAdmin(): boolean {
            return this.$store.getters["authentication/isAdmin"] as boolean;
        }
    }
</script>

<style>
    .padding-0 {
        padding: 0;
    }

/* .my-custom-col {
  max-width: 1900px;
} */
</style>
